// Ventures timeline animation

export const initTimeline = () => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const wrap = document.querySelector('.wwave');
  const svg = document.getElementById('wwaveSvg');
  if (!svg || !wrap) return;

  const main = svg.querySelector('.ww-main');
  const arrow = svg.querySelector('.ww-arrow');
  const years = svg.querySelectorAll('.ww-yr');
  const segs = svg.querySelectorAll('.ww-seglbl');
  const nodes = svg.querySelectorAll('.ww-node');

  const mlen = main.getTotalLength();
  main.style.strokeDasharray = mlen;
  main.style.strokeDashoffset = reduce ? 0 : mlen;

  const morph = main.querySelector('animate');
  if (reduce && morph) {
    morph.setAttribute('repeatCount', '1');
    morph.setAttribute('dur', '0.001s');
  }

  if (!reduce) {
    if (arrow) arrow.style.opacity = 0;
    years.forEach(y => y.style.opacity = 0);
    segs.forEach(s => s.style.opacity = 0);
    nodes.forEach(n => {
      n.style.opacity = 0;
      n.style.transformBox = 'fill-box';
      n.style.transformOrigin = 'center';
    });
  }

  function flash(node) {
    const ring = node.querySelector('.ww-ring');
    if (!ring) return;
    ring.classList.remove('flash');
    void ring.offsetWidth;
    ring.classList.add('flash');
  }

  function draw() {
    if (reduce) return;
    main.animate([{ strokeDashoffset: mlen }, { strokeDashoffset: 0 }], {
      duration: 2000,
      easing: 'cubic-bezier(.16,.84,.36,1)',
      fill: 'forwards',
    });
    if (arrow)
      arrow.animate([{ opacity: 0 }, { opacity: 0.95 }], {
        duration: 400,
        delay: 1900,
        easing: 'ease-out',
        fill: 'forwards',
      });
    years.forEach((y, i) => {
      y.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 500,
        delay: 700 + i * 90,
        easing: 'ease-out',
        fill: 'forwards',
      });
    });
    segs.forEach((s, i) => {
      s.animate([{ opacity: 0 }, { opacity: 0.6 }], {
        duration: 600,
        delay: 1500 + i * 120,
        easing: 'ease-out',
        fill: 'forwards',
      });
    });

    const order = Array.from(nodes).sort((a, b) =>
      +a.querySelector('.ww-c').getAttribute('cx') -
      +b.querySelector('.ww-c').getAttribute('cx')
    );

    order.forEach((n, i) => {
      const d = 1200 + i * 240;
      n.animate(
        [
          { opacity: 0, transform: 'scale(0)' },
          { opacity: 1, transform: 'scale(1)' },
        ],
        {
          duration: 520,
          delay: d,
          easing: 'cubic-bezier(.34,1.56,.64,1)',
          fill: 'forwards',
        }
      );
      setTimeout(() => flash(n), d + 260);
    });
  }

  if ('IntersectionObserver' in window && !reduce) {
    const io = new IntersectionObserver(
      entries => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            draw();
            io.disconnect();
          }
        });
      },
      { threshold: 0.25 }
    );
    io.observe(svg);
  } else {
    draw();
  }

  // Linkage: accordion <-> graph
  const MAP = {
    all: ['beep', 'soul', 'asha', 'beep2'],
    asha: ['asha'],
    soul: ['soul'],
    beep: ['beep', 'beep2'],
  };
  const NODE2ITEM = { beep: 'beep', beep2: 'beep', soul: 'soul', asha: 'asha' };

  function nodeByV(v) {
    return svg.querySelector('.ww-node[data-v="' + v + '"]');
  }

  function itemByV(v) {
    return document.querySelector('.witem[data-v="' + v + '"]');
  }

  window.__ventureHighlight = function (key, on) {
    if (!key) {
      clearHL();
      return;
    }
    if (on) {
      wrap.classList.add('dim');
      nodes.forEach(n => n.classList.remove('active'));
      (MAP[key] || []).forEach(v => {
        const n = nodeByV(v);
        if (n) {
          n.classList.add('active');
          flash(n);
        }
      });
    } else {
      clearHL();
    }
  };

  function clearHL() {
    wrap.classList.remove('dim');
    nodes.forEach(n => n.classList.remove('active'));
  }

  nodes.forEach(n => {
    const v = n.getAttribute('data-v');
    const itemKey = NODE2ITEM[v];
    const item = itemByV(itemKey);
    n.addEventListener('mouseenter', () => {
      if (item) item.classList.add('ghover');
    });
    n.addEventListener('mouseleave', () => {
      if (item) item.classList.remove('ghover');
    });
    function activate() {
      if (item && window.__ventureToggle) {
        window.__ventureToggle(item, true);
        item.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
    n.addEventListener('click', activate);
    n.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        activate();
      }
    });
  });
};
